import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/toast';
import 'bs-custom-file-input';
import '@sweco/sweco-digital-platforms/dist/js/sweco-components';
import '@sweco/sweco-digital-platforms/dist/js/sweco-bootstrap';
import App from './App';

// Set a default fontsize for optimal rendering
document.documentElement.style.fontSize="16px";

// Add NavBarNorth class to body so Sweco Bootstrap can render the page correctly
document.body.classList.add('navbarNorth', 'navbarSouth');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);